import { createSlice } from '@reduxjs/toolkit';

const loadFlags = () => {
  try {
    const raw = localStorage.getItem('featureFlags');
    return raw ? { contactsAccessUserdb: false, analyticsAccessUserdb: false, ...JSON.parse(raw) }
               : { contactsAccessUserdb: false, analyticsAccessUserdb: false };
  } catch {
    return { contactsAccessUserdb: false, analyticsAccessUserdb: false };
  }
};

const initialState = {
  notification: null,
  darkMode: localStorage.getItem('darkMode') === 'true',
  sidebarMobileOpen: false,
  featureFlags: loadFlags(),
  flagsLoaded: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.notification = {
        message: action.payload.message,
        type: action.payload.type,
      };
    },
    clearNotification: (state) => {
      state.notification = null;
    },
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      localStorage.setItem('darkMode', state.darkMode);
    },
    toggleMobileSidebar: (state) => {
      state.sidebarMobileOpen = !state.sidebarMobileOpen;
    },
    closeMobileSidebar: (state) => {
      state.sidebarMobileOpen = false;
    },
    setFeatureFlags: (state, action) => {
      state.featureFlags = { ...state.featureFlags, ...action.payload };
      state.flagsLoaded = true;
      try { localStorage.setItem('featureFlags', JSON.stringify(state.featureFlags)); } catch { /* ignore */ }
    },
  },
});

export const {
  showNotification,
  clearNotification,
  toggleDarkMode,
  toggleMobileSidebar,
  closeMobileSidebar,
  setFeatureFlags,
} = uiSlice.actions;

export default uiSlice.reducer;
